import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  alpha,
  DialogContentText,
} from '@mui/material';
import { useAppVersionUpdateContext } from '@/contexts/AppVersionUpdateContext';
import { Warning } from '@mui/icons-material';
import { Stack } from '@mui/system';

export const AppUpdateModal = () => {
  const { showUpdateModal, setShowUpdateModal, handleUpdateAppVersion } =
    useAppVersionUpdateContext();

  const handleUpdate = () => {
    handleUpdateAppVersion();
  };

  const handleClose = (
    _event: object,
    reason: 'escapeKeyDown' | 'backdropClick'
  ) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    setShowUpdateModal(false);
  };

  return (
    <Dialog
      open={showUpdateModal}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent sx={{ p: 2 }}>
        <Stack alignItems="center" justifyContent="center">
          <Box
            sx={(theme) => ({
              alignItems: 'center',
              bgcolor: alpha(theme.palette.warning.main, 0.16),
              borderRadius: '50%',
              color: theme.palette.warning.main,
              display: 'flex',
              height: 48,
              justifyContent: 'center',
              mb: 2,
              width: 48,
            })}
          >
            <Warning color="inherit" fontSize="medium" />
          </Box>
          <DialogContentText variant="h5" fontWeight="bold" mb={1}>
            Nova Versão Disponível
          </DialogContentText>
          <DialogContentText sx={{ textAlign: 'center' }}>
            Uma nova versão do sistema está disponível. Atualize para obter os
            últimos recursos e melhorias.
          </DialogContentText>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="center" width="100%" mb={2}>
          <Button
            onClick={() => setShowUpdateModal(false)}
            style={{ marginRight: 10 }}
          >
            Agora não
          </Button>
          <Button onClick={handleUpdate} color="warning" variant="contained">
            Atualizar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
